import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { environment } from "../../environments/environment";

/**
 * Blocks a route that only exists for development — the Material icon
 * reference, for instance.
 *
 * Hiding such a page from the navigation is not enough on its own: the route
 * stays reachable by typing the URL, and `/icons` is otherwise guarded only by
 * `rolesGuard`, which any global admin satisfies — including a customer's.
 *
 * Anyone who reaches it in production is sent to the overview rather than shown
 * an error, because from their side the page simply does not exist.
 */
export const devOnlyGuard: CanActivateFn = (): boolean | UrlTree => {
	if (!environment.production) {
		return true;
	}

	return inject(Router).createUrlTree(["/overview"]);
};
